import { useHashChange } from '../../../navigation';

/**
 * Returns the section id corresponding to the current hash.
 */
export function useURLHashSectionId() {
    return useHashChange().replace('#', '');
}
